import { Link } from 'react-router-dom';
import AnimateIn from './AnimateIn';

export default function CTABlock({ title, subtitle, primaryText, primaryLink, secondaryText, secondaryLink }) {
  return (
    <section data-testid="cta-block" className="relative py-28 md:py-36">
      <div className="absolute -inset-y-32 inset-x-0 pointer-events-none overflow-visible">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-yellow-400/[0.04] to-transparent" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] bg-yellow-400/[0.07] rounded-full blur-[180px]" />
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center relative z-10">
        <AnimateIn direction="up">
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-5 tracking-tight">
            {title || "Prêt à vendre votre voiture ?"}
          </h2>
        </AnimateIn>
        <AnimateIn direction="up" delay={0.1}>
          <p className="text-zinc-400 text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            {subtitle || "Obtenez une estimation gratuite en quelques minutes et vendez au meilleur prix à Montélimar."}
          </p>
        </AnimateIn>
        <AnimateIn direction="up" delay={0.2}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to={primaryLink || "/estimer-voiture"} data-testid="cta-primary"
              className="btn-primary py-4 px-10 text-sm neon-glow-hover">
              {primaryText || "Estimer mon véhicule"}
            </Link>
            {secondaryText && (
              <Link to={secondaryLink || "/vendre-voiture-montelimar"} data-testid="cta-secondary"
                className="btn-glass text-white font-semibold py-4 px-10 text-sm">
                {secondaryText}
              </Link>
            )}
          </div>
        </AnimateIn>
      </div>
    </section>
  );
}
